import React, { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FilterMatchMode } from 'primereact/api';


export const TableDetail = ({
    // data task
    ref,
    data,
    tableColumns,
    loading = true,
    dataKey,

    ...rest
}) => {
    /**@data => state for table data*/
    /**@loading => loading state=> true / false*/
    /**@tableColumns => tableColumns you want*/

    const [tableData, setTableData] = useState([]);


    useEffect(() => {
        if (typeof data === "undefined" || data === null) {
            return setTableData([]);
        }
        setTableData(data);
    }, [data]);

    const price = (data) => {
        let total_price = 0
        for (let i=0; i < data.length; i ++){
            total_price = total_price + (data[i]?.receive_quantity * data[i]?.unit_price) - (data[i]?.discount || 0)
        }
        return total_price
    } 


    return (
        <>
            <div className="datatable-filter-demo">
                <div className="card">
                    <DataTable
                        className="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-customers"
                        ref={ref}
                        // Data manage
                        value={tableData}
                        dataKey={dataKey}
                        loading={loading}
                        emptyMessage="Sorry, no matching records found !!!"
                        {...rest}
                    >


                        {tableColumns?.map((col, i) => (
                            <Column key={i} 
                                field={col.field} 
                                header={col.header} 
                                body={col.sortableBody}
                                style={{ minWidth: col.minWidth }} 
                            />
                        ))}
                    </DataTable>
                    <div className="grid">
                        <div className="col-12 md:col-10" style={{"textAlign": "center", "padding": "0px", "marginTop": "30px", "color": "#ab0dab", "fontWeight": "bold", "fontSize": "15px"}}>
                            <span>Total Price: </span>
                        </div>
                        <div className="col-12 md:col-2" style={{"textAlign": "center", "padding": "0px", "marginTop": "30px", "color": "#ab0dab", "fontWeight": "bold", "fontSize": "15px"}}>
                            <span style={{"marginLeft": "64px"}}>
                                {price(tableData).toLocaleString('en-US')}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};
